// TEXT ENHANCE (Fake AI)
export const enhancePrompt = async (input) => {
  return `A highly detailed cinematic scene of ${input}, with dramatic lighting, ultra-realistic textures, vibrant colors, and professional composition.`;
};

// IMAGE GENERATE (Prompt-based images)
export const generateImage = async (prompt) => {
  return [
    `https://picsum.photos/seed/${encodeURIComponent(prompt)}1/400/300`,
    `https://picsum.photos/seed/${encodeURIComponent(prompt)}2/400/300`
  ];
};

// IMAGE ANALYZE
export const analyzeImage = async (file) => {
  return {
    objects: "Person, Background",
    colors: "Blue, White",
    style: "Cinematic",
    description: "A visually appealing scene with balanced lighting and modern aesthetics."
  };
};